//node_modules
import { useState, useEffect, useCallback } from "react";
import { PatternFormat } from "react-number-format";
// import { isValidPhoneNumber } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { Select } from "react-functional-select";
import toast from "react-hot-toast";
import * as yup from "yup";
import axios from "axios";
import "tw-elements";

import checked from "../../assets/images/checked.png";
import unchecked from "../../assets/images/unchecked.png";
import checkingError from "../../assets/images/checking-error.png";
import TermsOfParticipation from "./TermsOfParticipation";
import PersonalDataProtection from "./PersonalDataProtection";
import { AiOutlineUpload } from "react-icons/ai";

import RegisterBgTop from "../../assets/images/register-bg.png";
import RegisterBgBottom from "../../assets/images/register-bg.png";
import WhiteBox1 from "../../assets/images/white-box-1.png";
import YellowBox1 from "../../assets/images/yellow-box-1.png";

const CustomFormError = ({ children }) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "0.875em",
      fontWeight: "600",
      color: "red",
    }}
  >
    {children}
  </span>
);

const Register = (props) => {
  const {
    control,
    handleSubmit,
    register,
    // reset,
    // clearErrors,
    // setError,
    // unregister,
    // getValues,
    // setValue,
    // getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
    shouldUnregister: true,
  });

  const [charCounts, setCharCounts] = useState({});

  function handleTextareaChange(event) {
    const { name, value } = event.target;
    if (value.length <= 2500) {
      setCharCounts({ ...charCounts, [name]: value.length });
    }
  }

  const [individualAppQuestions] = useState([
    {
      name: "individualQ1",
      questioneng:
        "Why would you like to be part of Unilever? What is your motivation behind it?",
      questiontr:
        "Neden Unilever’in bir parçası olmak istiyorsun? Motivasyonundan bahseder misin?",
    },
    {
      name: "individualQ2",
      questioneng:
        "What is the biggest change/challenge that you have had to deal with and how did you adapt to that change/challenge?",
      questiontr:
        "Karşılaştığın en büyük değişiklik/zorluk ne ve bu değişikliğe/zorluğa nasıl uyum sağladın?",
    },
    {
      name: "individualQ3",
      questioneng:
        "Which Unilever digital team is the one you would like to explore more? Why?",
      questiontr:
        "Hangi Unilever dijital ekibini daha yakından tanımak istersin? Neden?",
    },
    {
      name: "individualQ4",
      questioneng:
        "What kind of technologies/innovations do you think will emerge in digital world? How would these technologies/innovations benefit the FMCG sector in the long term?",
      questiontr:
        "Sizce dijitalde ne tür teknolojiler/inovasyonlar ortaya çıkacak? Bu teknolojiler/inovasyonlar uzun vadede FMCG sektörüne nasıl fayda sağlayacak?",
    },
  ]);

  const [teamAppQuestions] = useState([
    {
      name: "teamsQ1",
      questioneng:
        "Why would you like to be part of Unilever? What is your motivation behind it?",
      questiontr:
        "Neden Unilever’in bir parçası olmak istiyorsun? Motivasyonundan bahseder misin?",
    },
    {
      name: "teamsQ2",
      questioneng:
        "What is the biggest change/challenge that you have had to deal with and how did you adapt to that change/challenge?",
      questiontr:
        "Karşılaştığın en büyük değişiklik/zorluk ne ve bu değişikliğe/zorluğa nasıl uyum sağladın?",
    },
    {
      name: "teamsQ3",
      questioneng:
        "Which Unilever digital team is the one you would like to explore more? Why?",
      questiontr:
        "Hangi Unilever dijital ekibini daha yakından tanımak istersin? Neden?",
    },
    {
      name: "teamsQ4",
      questioneng:
        "What kind of technologies/innovations do you think will emerge in digital world? How would these technologies/innovations benefit the FMCG sector in the long term?",
      questiontr:
        "Sizce dijitalde ne tür teknolojiler/inovasyonlar ortaya çıkacak? Bu teknolojiler/inovasyonlar uzun vadede FMCG sektörüne nasıl fayda sağlayacak?",
    },
  ]);

  const [isIndividual, setIsIndividual] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [universities, setUniversites] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [cities, setCities] = useState([]);
  const [iclass, setClass] = useState([]);

  const getFilterOptionString = useCallback(
    (menuOption) => menuOption.data.value.toLocaleLowerCase("tr"),
    []
  );

  const fileSchema = yup
    .mixed()
    .test("fileSize", "The file is too large", (value, context) => {
      return value && value[0] && Math.round(value[0].size / 1024) <= 11264;
    });

  const fetchUniversites = () => {
    const url = "https://api.webeyondcreative.com/api/form/university";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const universities = response.data;
        setUniversites(
          universities.map((university) => ({
            value: university.name,
            label: university.name,
          }))
        );
      });
  };
  const fetchDepartments = () => {
    const url = "https://api.webeyondcreative.com/api/form/department";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const departments = response.data;
        setDepartments(
          departments.map((department) => ({
            value: department.name,
            label: department.name,
          }))
        );
      });
  };
  const fetchCities = () => {
    const url = "https://api.webeyondcreative.com/api/form/city";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const cities = response.data;
        setCities(
          cities.map((city) => ({
            value: city.name,
            label: city.name,
          }))
        );
      });
  };
  const fetchClasses = () => {
    const url = "https://api.webeyondcreative.com/api/form/class";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const classes = response.data;
        setClass(
          classes.map((iclass) => ({
            value: iclass.name,
            label: iclass.name,
          }))
        );
      });
  };
  const submitForm = (data) => {
    return;
    // setUploading(true);
    // axios.defaults.headers["X-Api-Token"] =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    // axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    // axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    // const formData = new FormData();

    // watch("participateStudyMarch3") && !isIndividual
    //   ? [
    //       "university",
    //       "department",
    //       "city",
    //       "class",
    //       "tm2university",
    //       "tm2department",
    //       "tm2city",
    //       "tm2class",
    //       "tm3university",
    //       "tm3department",
    //       "tm3city",
    //       "tm3class",
    //       "tm4university",
    //       "tm4department",
    //       "tm4city",
    //       "tm4class",
    //     ].forEach((item) => {
    //       data[item] = data[item].value;
    //     })
    //   : ["university", "department", "city", "class"].forEach((item) => {
    //       data[item] = data[item].value;
    //     });

    // for (const [key, value] of Object.entries(data)) {
    //   if (
    //     key === "file" ||
    //     key === "tm2file" ||
    //     key === "tm3file" ||
    //     key === "tm4file"
    //   ) {
    //     formData.append(key, value[0]);
    //   } else {
    //     formData.append(key, value);
    //   }
    // }
    // console.log(data);
    // // console.log(errors);
    // axios
    //   .post(
    //     "https://api.webeyondcreative.com/api/form/store/we_digicall",
    //     formData,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     if (response.data.exists === "success") {
    //       setUploading(false);
    //       toast.success(
    //         props.currentLang === "tr"
    //           ? "Başvurunuz alındı. İlginiz için teşekkürler."
    //           : "Your application has been sent. Thank you for your attention."
    //       );
    //       setTimeout(() => {
    //         window.location.reload();
    //       }, 2000);
    //     } else if (response.data.exists === "db_error") {
    //       setUploading(false);
    //       toast.error(
    //         props.currentLang === "tr"
    //           ? "Başvurunuz alınamadı!"
    //           : "Your application hasn't been sent!"
    //       );
    //     } else if (response.data.errors.email) {
    //       setUploading(false);
    //     }
    //   })
    //   .catch((error) => {
    //     setUploading(false);
    //     toast.error(
    //       props.currentLang === "tr"
    //         ? "Bu e-posta adresi ile daha önce başvuru yapılmıştır!"
    //         : "This e-mail address has already been applied for!"
    //     );
    //     console.log(error);
    //   });
  };

  useEffect(() => {
    fetchUniversites();
    fetchDepartments();
    fetchClasses();
    fetchCities();
  }, []);

  return (
    <section
      id={props.currentLang === "eng" ? "register" : "basvur"}
      className="w-full flex justify-center py-28 bg-white relative "
    >
      <div
        data-aos="fade-down"
        className="w-4/5 max-w-screen-xl space-y-16 z-[2]"
      >
        <div className="flex justify-center">
          <h2 className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-[#7705BC] font-bold text-center">
            {props.currentLang === "eng" ? "REGISTER" : "BAŞVUR"}
          </h2>
        </div>
        <div>
          <form
            // onSubmit={handleSubmit(submitForm)}
            className="space-y-10"
          >
            {/* Personal Data */}
            <div
              data-aos="fade-up"
              className="flex flex-col md:flex-row space-x-0 md:space-x-4 space-y-2 md:space-y-0"
            >
              <div className="flex flex-col w-full md:w-1/2 space-y-2">
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-[#1F36C7]"
                    htmlFor="firstname"
                  >
                    {props.currentLang === "eng" ? "Name" : "Ad"}
                  </label>
                  <input
                    {...register("firstname", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                      disabled: true,
                    })}
                    type="text"
                    className="error_firstname form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                    id="firstname"
                    aria-describedby="firstname"
                    placeholder={props.currentLang === "eng" ? "Name" : "Ad"}
                  />
                  <CustomFormError>{errors.firstname?.message}</CustomFormError>
                </div>
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-[#1F36C7]"
                    htmlFor="surname"
                  >
                    {props.currentLang === "eng" ? "Surname" : "Soyad"}
                  </label>
                  <input
                    {...register("surname", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                      disabled: true,
                    })}
                    type="text"
                    className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                    id="surname"
                    aria-describedby="surname"
                    placeholder={
                      props.currentLang === "eng" ? "Surname" : "Soyad"
                    }
                  />
                  <CustomFormError>{errors.surname?.message}</CustomFormError>
                </div>
                <div className="form-group space-y-2">
                  <label
                    className="text-base font-medium text-[#1F36C7]"
                    htmlFor="email"
                  >
                    {props.currentLang === "eng" ? "E-Mail" : "E-Posta"}
                  </label>
                  <input
                    {...register("email", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                      disabled: true,
                      pattern: {
                        value: /\S+@\S+\./,
                        message:
                          props.currentLang === "tr"
                            ? "Yanlış e-posta formatı!"
                            : "Incorrect email format!",
                      },
                    })}
                    type="email"
                    className="custom-email-control form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none lowercase placeholder:normal-case border-[#ced4da]"
                    id="email"
                    aria-describedby="email"
                    placeholder={
                      props.currentLang === "eng" ? "E-Mail" : "E-Posta"
                    }
                  />
                  <CustomFormError>{errors.email?.message}</CustomFormError>
                </div>
                <Controller
                  control={control}
                  name="phone"
                  disabled="true"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                  }) => (
                    <div className="form-group space-y-2 pointer-events-none">
                      <label
                        className="text-base font-medium text-[#1F36C7]"
                        htmlFor="phone"
                      >
                        {props.currentLang === "eng" ? "Phone" : "Telefon"}
                      </label>
                      <PatternFormat
                        name={name}
                        getInputRef={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        disabled={isSubmitting}
                        className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                        placeholder="0 5xx xxx xx xx"
                        format="0 ### ### ## ##"
                        mask="_"
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>
              <div className="flex flex-col w-full md:w-1/2 space-y-2 pointer-events-none">
                <Controller
                  control={control}
                  name="university"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                    disabled: true,
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-[#1F36C7]"
                        htmlFor="university"
                      >
                        {props.currentLang === "eng"
                          ? "University"
                          : "Üniversite"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={universities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="department"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-[#1F36C7]"
                        htmlFor="department"
                      >
                        {props.currentLang === "eng" ? "Department" : "Bölüm"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departments}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="class"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-[#1F36C7]"
                        htmlFor="class"
                      >
                        {props.currentLang === "eng" ? "Class" : "Sınıf"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={iclass}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="city"
                  rules={{
                    required:
                      props.currentLang === "tr"
                        ? "Bu alan zorunlu!"
                        : "This field is required!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group space-y-2"
                      aria-invalid={!!error}
                    >
                      <label
                        className="text-base font-medium text-[#1F36C7]"
                        htmlFor="city"
                      >
                        {props.currentLang === "eng" ? "City" : "Şehir"}
                      </label>
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={cities}
                        themeConfig={{
                          control: {
                            backgroundColor: "white",
                            borderRadius: 0,
                            height: "48px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder={
                          props.currentLang === "eng" ? "Select" : "Seç"
                        }
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>
            </div>
            {/* Cv Upload */}
            <div data-aos="fade-up" className="w-full flex pointer-events-none">
              <div className="form-group">
                <input
                  className="hidden form-control"
                  id="uploadCv"
                  type="file"
                  {...register("file", {
                    required:
                      props.currentLang === "eng"
                        ? "This field is required!"
                        : "Bu alan zorunlu!",
                    validate: async (value) =>
                      await fileSchema
                        .validate(value, { strict: true })
                        .catch((err) =>
                          props.currentLang === "eng"
                            ? "File is too big!"
                            : "Dosya boyutu çok büyük!"
                        ),
                  })}
                  accept="application/pdf"
                />
              </div>
              <div className="mt-2 flex flex-wrap justify-center items-center gap-3">
                <div className="flex bg-[#00D7C4] p-2 items-center h-fit full max-w-[19rem] min-h-10 overflow-hidden">
                  <p
                    className={
                      errors.file
                        ? "text-[#ff0000] whitespace-pre-wrap text-sm md:text-base font-medium m-0 w-full"
                        : "text-[#1F36C7] whitespace-pre-wrap text-sm md:text-base font-medium m-0 w-full"
                    }
                  >
                    {errors.file
                      ? errors.file?.message
                      : watch("file") && watch("file.0")
                      ? watch("file.0").name
                      : props.currentLang === "eng"
                      ? "Upload CV (max 10 mb, .pdf only)"
                      : "CV Yükle (max 10mb, yalnızca .pdf)"}
                  </p>
                  {/* <small color="danger">{errors.file?.message}</small> */}
                </div>

                {/* <label
                    className="h-10 w-10 p-2 self-center bg-[#1F36C7] text-white font-medium text-sm leading-tight shadow-md hover:bg-black hover:text-[#00D7C4] focus:outline-none focus:ring-0 active:bg-black active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
                    htmlFor="uploadCv"
                  >
                    <AiOutlineUpload className="text-2xl" />
                  </label> */}
              </div>
            </div>

            {/*Where Did You Hear*/}
            <div data-aos="fade-up" className="flex flex-col space-y-5">
              <label
                className="text-xl sm:text-xl md:text-2xl font-bold text-[#1F36C7]"
                htmlFor="where-did-you-hear"
              >
                {props.currentLang === "eng"
                  ? "Where did you hear about Digi-Call?"
                  : "Digi-Call etkinliğini nereden duydun?"}
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 pointer-events-none">
                <label
                  htmlFor="universityEvents"
                  className={
                    watch("wheredidyouhear") === "University Events"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "University Events"
                    : "Üniversite Etkinlikleri"}
                </label>
                <label
                  htmlFor="landmarkEvents"
                  className={
                    watch("wheredidyouhear") === "Landmark Events"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Landmark Events"
                    : "Landmark Etkinlikleri"}
                </label>
                <label
                  htmlFor="socialMedia"
                  className={
                    watch("wheredidyouhear") === "Social Media"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Social Media"
                    : "Sosyal Medya"}
                </label>
                <label
                  htmlFor="friendsFamily"
                  className={
                    watch("wheredidyouhear") === "Friends/Family"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng"
                    ? "Friends/Family"
                    : "Arkadaş/Aile"}
                </label>
                <label
                  htmlFor="mailing"
                  className={
                    watch("wheredidyouhear") === "Mailing"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng" ? "Mailing" : "E-posta"}
                </label>
                <label
                  htmlFor="other"
                  className={
                    watch("wheredidyouhear") === "Other"
                      ? "text-base font-medium bg-[#1F36C7] form-check-label text-white py-4 flex items-center justify-center hover:text-white cursor-pointer text-center"
                      : "text-base font-medium bg-[#00D7C4] form-check-label text-white py-4 flex items-center justify-center hover:text-[#1F36C7] cursor-pointer text-center"
                  }
                >
                  {props.currentLang === "eng" ? "Other" : "Diğer"}
                </label>
                <div className="hidden pointer-events-none">
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="universityEvents"
                    value="University Events"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="landmarkEvents"
                    value="Landmark Events"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="socialMedia"
                    value="Social Media"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="friendsFamily"
                    value="Friends/Family"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="mailing"
                    value="Mailing"
                  />
                  <input
                    className="hidden"
                    {...register("wheredidyouhear", {
                      required:
                        props.currentLang === "tr"
                          ? "Bu alan zorunlu!"
                          : "This field is required!",
                    })}
                    type="radio"
                    id="other"
                    value="Other"
                  />
                </div>
              </div>
              <CustomFormError>
                {errors.wheredidyouhear?.message}
              </CustomFormError>
            </div>
            {/* 3 March Activity */}
            <div
              data-aos="fade-up"
              className="flex flex-row items-start space-x-3"
            >
              <label
                htmlFor="participateStudyMarch3"
                className="pointer-events-none mt-1"
              >
                <img
                  src={
                    errors.participateStudyMarch3
                      ? checkingError
                      : watch("participateStudyMarch3") === false
                      ? unchecked
                      : checked
                  }
                  alt="participateStudyMarch3Check"
                  width={24}
                />
              </label>
              {props.currentLang === "eng" ? (
                <p
                  // onClick={() => {
                  //   props.setModalOn(true);
                  // }}
                  className="text-xs md:text-base font-normal text-black pointer-events-none"
                  style={{ maxWidth: "80%" }}
                >
                  I would like to participate in the case study that will be
                  held on May 12nd.
                </p>
              ) : (
                <p
                  onClick={() => {
                    props.setModalOn(true);
                  }}
                  className="text-xs md:text-base font-normal text-black"
                  style={{ maxWidth: "80%" }}
                >
                  12 Mayıs'ta gerçekleştirilecek vaka etkinliğine katılmak
                  istiyorum.
                </p>
              )}
              <input
                onClick={() => {
                  props.setModalOn(true);
                }}
                className="hidden"
                id="participateStudyMarch3"
                type="checkbox"
                disabled={watch("participateStudyMarch3") === false}
                {...register("participateStudyMarch3")}
              />
            </div>
            {/* Team Application */}
            {watch("participateStudyMarch3") && (
              <div className="w-full flex flex-col space-y-5">
                <div
                  onClick={() => {
                    isIndividual
                      ? setIsIndividual(false)
                      : setIsIndividual(true);
                  }}
                  className="w-full bg-[#1F36C7] py-2 cursor-pointer"
                >
                  <p className="text-lg sm:text-xl md:text-2xl text-white font-bold text-center">
                    {props.currentLang === "eng"
                      ? "TEAM APPLICATION"
                      : "EKİP BAŞVURUSU"}
                  </p>
                </div>
                {!isIndividual && (
                  <div className="w-full flex flex-col space-y-5">
                    <div className="w-full flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-6">
                      {/* Team Member 2  */}
                      <div className="w-full lg:w-1/3 flex flex-col space-y-4">
                        <div className="w-full bg-[#00D7C4] py-2">
                          <p className="text-lg md:text-2xl text-white font-bold text-center">
                            {props.currentLang === "eng"
                              ? "Team Member #2"
                              : "Ekip Üyesi #2"}
                          </p>
                        </div>
                        <div className="w-full flex flex-col space-y-3">
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm2firstname"
                            >
                              {props.currentLang === "eng" ? "Name" : "Ad"}
                            </label>
                            <input
                              {...register("tm2firstname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="error_firstname form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm2firstname"
                              aria-describedby="tm2firstname"
                              placeholder={
                                props.currentLang === "eng" ? "Name" : "Ad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm2firstname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm2surname"
                            >
                              {props.currentLang === "eng"
                                ? "Surname"
                                : "Soyad"}
                            </label>
                            <input
                              {...register("tm2surname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm2surname"
                              aria-describedby="tm2surname"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "Surname"
                                  : "Soyad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm2surname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm2email"
                            >
                              {props.currentLang === "eng"
                                ? "E-Mail"
                                : "E-Posta"}
                            </label>
                            <input
                              {...register("tm2email", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                                pattern: {
                                  value: /\S+@\S+\./,
                                  message:
                                    props.currentLang === "tr"
                                      ? "Yanlış e-posta formatı!"
                                      : "Incorrect email format!",
                                },
                              })}
                              type="email"
                              className="custom-email-control form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none lowercase placeholder:normal-case border-[#ced4da]"
                              id="tm2email"
                              aria-describedby="tm2email"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "E-Mail"
                                  : "E-Posta"
                              }
                            />
                            <CustomFormError>
                              {errors.tm2email?.message}
                            </CustomFormError>
                          </div>
                          <Controller
                            control={control}
                            name="tm2phone"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { error },
                            }) => (
                              <div className="form-group space-y-2">
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm2phone"
                                >
                                  {props.currentLang === "eng"
                                    ? "Phone"
                                    : "Telefon"}
                                </label>
                                <PatternFormat
                                  name={name}
                                  getInputRef={ref}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  disabled={isSubmitting}
                                  className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da] pointer-events-none"
                                  placeholder="0 5xx xxx xx xx"
                                  format="0 ### ### ## ##"
                                  mask="_"
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm2university"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm2university"
                                >
                                  {props.currentLang === "eng"
                                    ? "University"
                                    : "Üniversite"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={universities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm2department"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm2department"
                                >
                                  {props.currentLang === "eng"
                                    ? "Department"
                                    : "Bölüm"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={departments}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm2class"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm2class"
                                >
                                  {props.currentLang === "eng"
                                    ? "Class"
                                    : "Sınıf"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={iclass}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm2city"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm2city"
                                >
                                  {props.currentLang === "eng"
                                    ? "City"
                                    : "Şehir"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={cities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <div className="w-full flex">
                            <div className="form-group">
                              <input
                                className="hidden form-control pointer-events-none"
                                id="tm2uploadCv"
                                type="file"
                                {...register("tm2file", {
                                  required:
                                    props.currentLang === "eng"
                                      ? "This field is required!"
                                      : "Bu alan zorunlu!",
                                  disabled: true,
                                  // validate: async (value) =>
                                  //   await fileSchema
                                  //     .validate(value, { strict: true })
                                  //     .catch((err) =>
                                  //       props.currentLang === "eng"
                                  //         ? "File is too big!"
                                  //         : "Dosya boyutu çok büyük!"
                                  //     ),
                                })}
                                accept="application/pdf"
                              />
                            </div>
                            <div className="mt-2 flex flex-row space-x-3">
                              <div className="flex bg-[#00D7C4] px-2 items-center h-10 max-w-[19rem] ">
                                <p
                                  className={
                                    errors.file
                                      ? "text-[#ff0000] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                      : "text-[#1F36C7] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                  }
                                >
                                  {errors.tm2file
                                    ? errors.tm2file?.message
                                    : watch("tm2file") && watch("tm2file.0")
                                    ? watch("tm2file.0").name
                                    : props.currentLang === "eng"
                                    ? "Upload CV (max 10 mb, .pdf only)"
                                    : "CV Yükle (max 10mb, yalnızca .pdf)"}
                                </p>
                                {/* <small color="danger">{errors.file?.message}</small> */}
                              </div>
                              <label
                                className="h-10 w-10 p-2 bg-[#1F36C7] text-white font-medium text-sm leading-tight shadow-md hover:bg-black hover:text-[#00D7C4] focus:outline-none focus:ring-0 active:bg-black active:shadow-lg transition duration-150 ease-in-out pointer-events-none"
                                // htmlFor="tm2uploadCv"
                              >
                                <AiOutlineUpload className="text-2xl" />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Team Member 3  */}
                      <div className="w-full lg:w-1/3 flex flex-col space-y-4">
                        <div className="w-full bg-[#00D7C4] py-2">
                          <p className="text-lg md:text-2xl text-white font-bold text-center">
                            {props.currentLang === "eng"
                              ? "Team Member #3"
                              : "Ekip Üyesi #3"}
                          </p>
                        </div>
                        <div className="w-full flex flex-col space-y-3">
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm3firstname"
                            >
                              {props.currentLang === "eng" ? "Name" : "Ad"}
                            </label>
                            <input
                              {...register("tm3firstname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="error_firstname form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm3firstname"
                              aria-describedby="tm3firstname"
                              placeholder={
                                props.currentLang === "eng" ? "Name" : "Ad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm3firstname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm3surname"
                            >
                              {props.currentLang === "eng"
                                ? "Surname"
                                : "Soyad"}
                            </label>
                            <input
                              {...register("tm3surname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm3surname"
                              aria-describedby="tm3surname"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "Surname"
                                  : "Soyad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm3surname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm3email"
                            >
                              {props.currentLang === "eng"
                                ? "E-Mail"
                                : "E-Posta"}
                            </label>
                            <input
                              {...register("tm3email", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                                pattern: {
                                  value: /\S+@\S+\./,
                                  message:
                                    props.currentLang === "tr"
                                      ? "Yanlış e-posta formatı!"
                                      : "Incorrect email format!",
                                },
                              })}
                              type="email"
                              className="custom-email-control form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none lowercase placeholder:normal-case border-[#ced4da]"
                              id="tm3email"
                              aria-describedby="tm3email"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "E-Mail"
                                  : "E-Posta"
                              }
                            />
                            <CustomFormError>
                              {errors.tm3email?.message}
                            </CustomFormError>
                          </div>
                          <Controller
                            control={control}
                            name="tm3phone"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { error },
                            }) => (
                              <div className="form-group space-y-2">
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm3phone"
                                >
                                  {props.currentLang === "eng"
                                    ? "Phone"
                                    : "Telefon"}
                                </label>
                                <PatternFormat
                                  name={name}
                                  getInputRef={ref}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  disabled={isSubmitting}
                                  className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                                  placeholder="0 5xx xxx xx xx"
                                  format="0 ### ### ## ##"
                                  mask="_"
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm3university"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm3university"
                                >
                                  {props.currentLang === "eng"
                                    ? "University"
                                    : "Üniversite"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={universities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm3department"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm3department"
                                >
                                  {props.currentLang === "eng"
                                    ? "Department"
                                    : "Bölüm"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={departments}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm3class"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm3class"
                                >
                                  {props.currentLang === "eng"
                                    ? "Class"
                                    : "Sınıf"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={iclass}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm3city"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm3city"
                                >
                                  {props.currentLang === "eng"
                                    ? "City"
                                    : "Şehir"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={cities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <div className="w-full flex">
                            <div className="form-group">
                              <input
                                className="hidden form-control"
                                id="tm3uploadCv"
                                type="file"
                                {...register("tm3file", {
                                  required:
                                    props.currentLang === "eng"
                                      ? "This field is required!"
                                      : "Bu alan zorunlu!",
                                  validate: async (value) =>
                                    await fileSchema
                                      .validate(value, { strict: true })
                                      .catch((err) =>
                                        props.currentLang === "eng"
                                          ? "File is too big!"
                                          : "Dosya boyutu çok büyük!"
                                      ),
                                })}
                                accept="application/pdf"
                              />
                            </div>
                            <div className="mt-2 flex flex-row space-x-3">
                              <div className="flex bg-[#00D7C4] px-2 items-center h-10 max-w-[19rem] ">
                                <p
                                  className={
                                    errors.file
                                      ? "text-[#ff0000] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                      : "text-[#1F36C7] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                  }
                                >
                                  {errors.tm3file
                                    ? errors.tm3file?.message
                                    : watch("tm3file") && watch("tm3file.0")
                                    ? watch("tm3file.0").name
                                    : props.currentLang === "eng"
                                    ? "Upload CV (max 10 mb, .pdf only)"
                                    : "CV Yükle (max 10mb, yalnızca .pdf)"}
                                </p>
                                {/* <small color="danger">{errors.file?.message}</small> */}
                              </div>
                              <label
                                className="h-10 w-10 p-2 bg-[#1F36C7] text-white font-medium text-sm leading-tight shadow-md hover:bg-black hover:text-[#00D7C4] focus:outline-none focus:ring-0 active:bg-black active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
                                htmlFor="tm3uploadCv"
                              >
                                <AiOutlineUpload className="text-2xl" />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Team Member 4  */}
                      <div className="w-full lg:w-1/3 flex flex-col space-y-4">
                        <div className="w-full bg-[#00D7C4] py-2">
                          <p className="text-lg md:text-2xl text-white font-bold text-center">
                            {props.currentLang === "eng"
                              ? "Team Member #4"
                              : "Ekip Üyesi #4"}
                          </p>
                        </div>
                        <div className="w-full flex flex-col space-y-3">
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm4firstname"
                            >
                              {props.currentLang === "eng" ? "Name" : "Ad"}
                            </label>
                            <input
                              {...register("tm4firstname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="error_firstname form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm4firstname"
                              aria-describedby="tm4firstname"
                              placeholder={
                                props.currentLang === "eng" ? "Name" : "Ad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm4firstname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm4surname"
                            >
                              {props.currentLang === "eng"
                                ? "Surname"
                                : "Soyad"}
                            </label>
                            <input
                              {...register("tm4surname", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                              })}
                              type="text"
                              className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                              id="tm4surname"
                              aria-describedby="tm4surname"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "Surname"
                                  : "Soyad"
                              }
                            />
                            <CustomFormError>
                              {errors.tm4surname?.message}
                            </CustomFormError>
                          </div>
                          <div className="form-group space-y-2">
                            <label
                              className="text-base font-medium text-[#1F36C7]"
                              htmlFor="tm4email"
                            >
                              {props.currentLang === "eng"
                                ? "E-Mail"
                                : "E-Posta"}
                            </label>
                            <input
                              {...register("tm4email", {
                                required:
                                  props.currentLang === "tr"
                                    ? "Bu alan zorunlu!"
                                    : "This field is required!",
                                pattern: {
                                  value: /\S+@\S+\./,
                                  message:
                                    props.currentLang === "tr"
                                      ? "Yanlış e-posta formatı!"
                                      : "Incorrect email format!",
                                },
                              })}
                              type="email"
                              className="custom-email-control form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none lowercase placeholder:normal-case border-[#ced4da]"
                              id="tm4email"
                              aria-describedby="tm4email"
                              placeholder={
                                props.currentLang === "eng"
                                  ? "E-Mail"
                                  : "E-Posta"
                              }
                            />
                            <CustomFormError>
                              {errors.tm4email?.message}
                            </CustomFormError>
                          </div>
                          <Controller
                            control={control}
                            name="tm4phone"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { error },
                            }) => (
                              <div className="form-group space-y-2">
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm4phone"
                                >
                                  {props.currentLang === "eng"
                                    ? "Phone"
                                    : "Telefon"}
                                </label>
                                <PatternFormat
                                  name={name}
                                  getInputRef={ref}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  value={value}
                                  disabled={isSubmitting}
                                  className="form-control block rounded-none w-full h-12 px-3 py-3 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none border-[#ced4da]"
                                  placeholder="0 5xx xxx xx xx"
                                  format="0 ### ### ## ##"
                                  mask="_"
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm4university"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm4university"
                                >
                                  {props.currentLang === "eng"
                                    ? "University"
                                    : "Üniversite"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={universities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm4department"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm4department"
                                >
                                  {props.currentLang === "eng"
                                    ? "Department"
                                    : "Bölüm"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={departments}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm4class"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm4class"
                                >
                                  {props.currentLang === "eng"
                                    ? "Class"
                                    : "Sınıf"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={iclass}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <Controller
                            control={control}
                            name="tm4city"
                            rules={{
                              required:
                                props.currentLang === "tr"
                                  ? "Bu alan zorunlu!"
                                  : "This field is required!",
                            }}
                            render={({
                              field: { onChange, onBlur, value, name, ref, id },
                              fieldState: { error },
                            }) => (
                              <div
                                className="form-group space-y-2"
                                aria-invalid={!!error}
                              >
                                <label
                                  className="text-base font-medium text-[#1F36C7]"
                                  htmlFor="tm4city"
                                >
                                  {props.currentLang === "eng"
                                    ? "City"
                                    : "Şehir"}
                                </label>
                                <Select
                                  id={id}
                                  ref={ref}
                                  name={name}
                                  isClearable
                                  options={cities}
                                  themeConfig={{
                                    control: {
                                      backgroundColor: "white",
                                      borderRadius: 0,
                                      height: "48px",
                                      boxShadow: "none",
                                    },
                                  }}
                                  placeholder={
                                    props.currentLang === "eng"
                                      ? "Select"
                                      : "Seç"
                                  }
                                  onOptionChange={onChange}
                                  onInputBlur={onBlur}
                                  value={value}
                                  filterIgnoreAccents={true}
                                  getFilterOptionString={getFilterOptionString}
                                />
                                <CustomFormError>
                                  {error && error.message}
                                </CustomFormError>
                              </div>
                            )}
                          />
                          <div className="w-full flex">
                            <div className="form-group">
                              <input
                                className="hidden form-control"
                                id="tm4uploadCv"
                                type="file"
                                {...register("tm4file", {
                                  required:
                                    props.currentLang === "eng"
                                      ? "This field is required!"
                                      : "Bu alan zorunlu!",
                                  disabled: true,
                                  validate: async (value) =>
                                    await fileSchema
                                      .validate(value, { strict: true })
                                      .catch((err) =>
                                        props.currentLang === "eng"
                                          ? "File is too big!"
                                          : "Dosya boyutu çok büyük!"
                                      ),
                                })}
                                accept="application/pdf"
                              />
                            </div>
                            <div className="mt-2 flex flex-row space-x-3">
                              <div className="flex bg-[#00D7C4] px-2 items-center h-10 max-w-[19rem] ">
                                <p
                                  className={
                                    errors.file
                                      ? "text-[#ff0000] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                      : "text-[#1F36C7] text-sm md:text-base font-medium m-0 w-full overflow-hidden"
                                  }
                                >
                                  {errors.tm4file
                                    ? errors.tm4file?.message
                                    : watch("tm4file") && watch("tm4file.0")
                                    ? watch("tm4file.0").name
                                    : props.currentLang === "eng"
                                    ? "Upload CV (max 10 mb, .pdf only)"
                                    : "CV Yükle (max 10mb, yalnızca .pdf)"}
                                </p>
                                {/* <small color="danger">{errors.file?.message}</small> */}
                              </div>
                              <label
                                className=" h-10 w-10 p-2 bg-[#1F36C7] text-white font-medium text-sm leading-tight shadow-md hover:bg-black hover:text-[#00D7C4] focus:outline-none focus:ring-0 active:bg-black active:shadow-lg transition duration-150 ease-in-out pointer-events-none"
                                disabled
                              >
                                <AiOutlineUpload className="text-2xl pointer-events-none" />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex flex-col space-y-3">
                      {teamAppQuestions.map((q, index) => {
                        return (
                          <div
                            key={q.name}
                            className="form-group flex flex-col space-y-2"
                          >
                            <div className="w-full flex items-start space-x-2">
                              <div className="w-5 h-5 bg-[#1F36C7] rounded-full flex items-center justify-center">
                                <p className="text-xs font-medium text-white">
                                  {index + 1}
                                </p>
                              </div>
                              <label
                                className="text-xs md:text-base text-black font-normal"
                                style={{ maxWidth: "80%" }}
                                htmlFor={q.name}
                              >
                                {props.currentLang === "eng"
                                  ? q.questioneng
                                  : q.questiontr}
                              </label>
                            </div>
                            <div className="w-full">
                              <textarea
                                {...register(q.name, {
                                  required: "Bu alan zorunlu!",
                                  maxLength: {
                                    value: 2500,
                                    message:
                                      "En fazla 2500 karakter girebilirsiniz!",
                                  },
                                })}
                                onChange={handleTextareaChange}
                                style={{ boxShadow: "none" }}
                                className="form-control block rounded-none w-full h-[118px] min-h-[118px] max-h-[200px] px-3 py-3  font-normal text-black text-base bg-transparent bg-clip-padding transition ease-in-out m-0 focus:text-black focus:bg-white focus:outline-none border border-solid focus:border-[#1F36C7] border-[#ced4da]"
                                id={q.name}
                                aria-describedby={q.name}
                                placeholder=""
                              />
                              <CustomFormError>
                                {errors[q.name]?.message}
                              </CustomFormError>
                              <div>{charCounts[q.name] ?? 0}/2500</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* Individual Application Questions */}
            {watch("participateStudyMarch3") && (
              <div className="w-full flex flex-col space-y-3">
                <div
                  onClick={() => {
                    isIndividual
                      ? setIsIndividual(false)
                      : setIsIndividual(true);
                  }}
                  className="w-full bg-[#1F36C7] py-2 cursor-pointer"
                >
                  <p className="text-lg sm:text-xl md:text-2xl text-white font-bold text-center">
                    {props.currentLang === "eng"
                      ? "INDIVIDUAL APPLICATION"
                      : "BİREYSEL BAŞVURU"}
                  </p>
                </div>
                {isIndividual && (
                  <div className="w-full flex flex-col space-y-3">
                    {individualAppQuestions.map((q, index) => {
                      return (
                        <div
                          key={q.name}
                          className="form-group flex flex-col space-y-2"
                        >
                          <div className="w-full flex items-start space-x-2">
                            <div className="w-5 h-5 bg-[#1F36C7] rounded-full flex items-center justify-center mt-1">
                              <p className="text-xs font-medium text-white">
                                {index + 1}
                              </p>
                            </div>
                            <label
                              className="text-xs md:text-base text-black font-normal"
                              style={{ maxWidth: "80%" }}
                              htmlFor={q.name}
                            >
                              {props.currentLang === "eng"
                                ? q.questioneng
                                : q.questiontr}
                            </label>
                          </div>
                          <div className="w-full">
                            <textarea
                              {...register(q.name, {
                                required: "Bu alan zorunlu!",
                                maxLength: {
                                  value: 2500,
                                  message:
                                    "En fazla 2500 karakter girebilirsiniz!",
                                },
                              })}
                              onChange={handleTextareaChange}
                              style={{ boxShadow: "none" }}
                              className="form-control block rounded-none w-full h-[118px] min-h-[118px] max-h-[200px] px-3 py-3  font-normal text-black text-base bg-transparent bg-clip-padding transition ease-in-out m-0 focus:text-black focus:bg-white focus:outline-none border border-solid border-[#ced4da] focus:border-[#1F36C7]"
                              id={q.name}
                              aria-describedby={q.name}
                              placeholder=""
                            />
                            <CustomFormError>
                              {errors[q.name]?.message}
                            </CustomFormError>
                            <div>{charCounts[q.name] ?? 0}/2500</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {/* term of part. */}
            <div
              data-aos="fade-up"
              className="flex flex-col space-y-4 pointer-events-none"
            >
              <div className="flex flex-row items-center space-x-3 pointer-events-none">
                <label
                  htmlFor="personaldataprotection"
                  className="pointer-events-none mt-1"
                >
                  <img
                    src={
                      watch("personaldataprotection") === false
                        ? unchecked
                        : checked
                    }
                    alt="personalDataProtectionCheck"
                    width={24}
                  />
                </label>
                {props.currentLang === "eng" ? (
                  <p
                    className="text-xs md:text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    I consent to the processing of my personal data, which I
                    provided to Unilever Sanayi ve Ticaret Türk A.Ş. within the
                    scope of the event participation, in accordance wit &nbsp;
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#personalDataProtectionModal"
                      // data-bs-target="#termsOfParticipationModal"
                      className="underline cursor-pointer"
                    >
                      the Clarification Text on the Processing of Personal Data
                      within the scope of the Digi-Call event
                    </span>
                    .
                  </p>
                ) : (
                  <p
                    className="text-xs md:text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    Etkinlik katılımı kapsamında Unilever Sanayi ve Ticaret Türk
                    A.Ş.’ye sağladığım kişisel verilerimin &nbsp;
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#personalDataProtectionModal"
                      // data-bs-target="#termsOfParticipationModal"
                      className="underline cursor-pointer"
                    >
                      Digi-Call etkinliği kapsamında Kişisel Verilerin
                      İşlenmesine Dair Aydınlatma Metni
                    </span>{" "}
                    uyarınca işlenmesine izin veriyorum.
                  </p>
                )}
                <input
                  className="hidden"
                  id="termsofparticipation"
                  type="checkbox"
                  {...register("termsofparticipation")}
                />
              </div>
              <div className="flex flex-row space-x-3 items-start">
                <label
                  htmlFor="termsofparticipation"
                  className="pointer-events-none"
                >
                  <img
                    src={
                      watch("termsofparticipation") === false
                        ? unchecked
                        : checked
                    }
                    alt="termsOfParticipationCheck"
                    width={24}
                  />
                </label>
                {props.currentLang === "eng" ? (
                  <p
                    className="text-xs md:text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#termsOfParticipationModal"
                      className="pointer-events-none"
                    >
                      I give communication permission to Unilever Sanayi ve
                      Ticaret Türk A.Ş. and third parties within the scope of
                      Commercial Communication and Commercial &nbsp; Electronic
                      Message Regulation
                    </span>{" "}
                  </p>
                ) : (
                  <p
                    className="text-xs md:text-base font-normal text-black"
                    style={{ maxWidth: "80%" }}
                  >
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#termsOfParticipationModal"
                      className="cursor-pointer"
                    >
                      Ticari İletişim ve Ticari Elektronik İleti Yönetmeliği
                      kapsamında Unilever Sanayi ve Ticaret Türk A.Ş.'ye ve
                      üçüncü taraflara &nbsp; iletişim izni veriyorum.
                    </span>{" "}
                  </p>
                )}

                <input
                  className="hidden pointer-events-none"
                  id="personaldataprotection"
                  type="checkbox"
                  {...register("personaldataprotection")}
                />
              </div>
            </div>
            {/* submit */}
            <div data-aos="fade-up" className="flex justify-center">
              <button
                type="submit"
                disabled="true"
                className="pointer-events-none min-w-80 min-h-16 text-base sm:text-base md:text-3xl text-[#1F36C7] hover:text-white font-bold bg-[#00D7C4] rounded-md px-10 md:px-24 py-4"
              >
                {uploading && (
                  <div className="flex justify-center items-center">
                    <div
                      className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full relative box-border"
                      role="status"
                    >
                      <div className="w-5 h-5 bg-[#00D7C4] rounded-t-full rounded-r-full absolute -top-3 right-0 box-border"></div>
                    </div>
                  </div>
                )}
                {!uploading && props.currentLang === "eng" && "REGISTER"}
                {!uploading && props.currentLang === "tr" && "BAŞVUR"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <img
        className="absolute w-3/5 top-2 -left-10 z-0 select-none"
        src={RegisterBgTop}
        alt="register bg top"
      />
      <div className="w-full absolute bottom-0 overflow-hidden h-full">
        <img
          className="absolute w-3/5 bottom-2 -right-10 z-0 select-none"
          src={RegisterBgBottom}
          alt="register bg-bottom"
        />
      </div>
      <img
        className="w-[100px] lg:w-[200px] absolute right-[15%] -top-[50px] lg:-top-[100px] select-none animate-[wiggle_10s_ease-in-out_infinite]"
        src={WhiteBox1}
        alt="white box"
      />
      <img
        className="w-[35px] lg:w-[70px] absolute right-1/3 top-14 select-none animate-[spinselfrotate_10s_ease-in-out_infinite]"
        src={YellowBox1}
        alt="yellow box"
      />
      <PersonalDataProtection isChecked={watch("personaldataprotection")} />
      <TermsOfParticipation isChecked={watch("termsofparticipation")} />
    </section>
  );
};

export default Register;
